import { ArrowRightOutlined, GiftOutlined } from "@ant-design/icons";
import { HiOutlineEye } from "react-icons/hi2";
import Navbar from "../Menu/Navbar";
import Footer from "./Sections/Footer";
import PageHeaderAllPage from "../../Components/layouts/PageHeaderAllPage";
import Preloader from "../../Components/Preloader";
import { Col, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../apis/store";
import { useEffect } from "react";
import { toGetOffers } from "../../apis/actions/offers.actions";
import { Link } from "react-router-dom";
import ListFetchLoader from "../../Components/biblio/ListFetchLoader";

import { useTranslation } from "react-i18next";

const offerDetailState = (el: {
  id: unknown;
  name: string;
  summary: string;
  details: string;
  image_1920: string;
}) => ({
  id: el.id,
  name: el.name,
  summary: el.summary,
  details: el.details,
  image: el.image_1920,
});

const Offres = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { t, i18n } = useTranslation();
  const { list, status } = useSelector((state: RootState) => state.offers.offers);
  const isLoading = status === "" || status === "idle";

  useEffect(() => {
    dispatch(toGetOffers(i18n.language));
  }, [dispatch, i18n.language]);
  return (
    <>
      <Navbar type="internal" />
      <Preloader />
      <main className="main">
        <PageHeaderAllPage
          tone="brand"
          showMenu
          current={t("menu.offers")}
          banner="assets/imgs/offres/banner.png"
          link="offers"
        />
        <section className="ac-offers-page ac--font-expo" dir={i18n.dir()}>
          <div className="container">
            <div className="ac-offers-page__heading">
              <div>
                <h2>{t("offersPage.heading")}</h2>
                <p>{t("offersPage.intro")}</p>
              </div>
              {!isLoading && status !== "rejected" && list.length > 0 && (
                <span className="ac-offers-page__count">
                  <GiftOutlined aria-hidden="true" />
                  {t("offersPage.total", { value: list.length })}
                </span>
              )}
            </div>
            {isLoading ? (
              <ListFetchLoader loading />
            ) : status === "rejected" ? (
              <div className="ac-offers-page__state" role="alert">
                <GiftOutlined aria-hidden="true" />
                <h3>{t("offersPage.error")}</h3>
                <button type="button" onClick={() => dispatch(toGetOffers(i18n.language))}>
                  {t("offersPage.retry")}
                </button>
              </div>
            ) : list.length === 0 ? (
              <div className="ac-offers-page__state" role="status">
                <GiftOutlined aria-hidden="true" />
                <h3>{t("offersPage.empty")}</h3>
                <p>{t("offersPage.emptyHint")}</p>
              </div>
            ) : (
              <Row gutter={[24, 28]}>
                {list.map((el: (typeof list)[number], i: number) => (
                  <Col key={el.id ?? i} xs={24} sm={12} lg={8} className="ac-offer-col">
                    <Link
                      to="/offer-detail"
                      state={offerDetailState(el)}
                      className="ac-offer-card"
                      aria-label={t("offersPage.openOfferAria", { name: el.name })}
                    >
                      <div className="ac-offer-card__image">
                        {el.image_1920 ? (
                          <img src={el.image_1920} alt="" loading="lazy" decoding="async" />
                        ) : (
                          <GiftOutlined className="ac-offer-card__placeholder" aria-hidden="true" />
                        )}
                        <span className="ac-offer-card__overlay" aria-hidden="true">
                          <span className="ac-offer-card__view"><HiOutlineEye /></span>
                        </span>
                      </div>
                      <div className="ac-offer-card__info">
                        <h3>{el.name}</h3>
                        <p className="ac-offer-card__summary">{el.summary}</p>
                      </div>
                      <div className="ac-offer-card__footer">
                        <span>{t("offersPage.cardHover")}</span>
                        <span className="ac-offer-card__arrow" aria-hidden="true"><ArrowRightOutlined /></span>
                      </div>
                    </Link>
                  </Col>
                ))}
              </Row>
            )}
          </div>
        </section>
      </main>
      <Footer type="external" />
    </>
  );
};

export default Offres;
